import React, { Component, Fragment } from 'react';
import Helmet from 'react-helmet';

const initialState = {
}

class Error extends Component {
  state = initialState

  // 初期処理
  componentDidMount() {

    // 「GA計測用データレイヤースクリプト追加処理」を呼出す
    window.addDataLayerScript('jmbauth_error');

  }

  // Rtoster部分の描画
  getDesignRtoster = () => {
    return [
      <script key="script1" type="text/javascript">{`
        var JALCOJP = Rtoaster.Cookie.get("JALCOJP");
        var memNo = Rtoaster.Cookie.get("memNo");
        var rt_update_cookie = ""

        if (JALCOJP && !memNo) {
          rt_update_cookie = Rtoaster.Cookie.get("JALCOJP");
        } else if (!JALCOJP && memNo) {
          rt_update_cookie = Rtoaster.Cookie.get("memNo");
        } else if (JALCOJP && memNo) {
          rt_update_cookie = Rtoaster.Cookie.get("memNo");
        } else {

        };

        var rt_data = {
          user_id: rt_update_cookie
        };
      `}</script>,
      <script key="script2" type="text/javascript">{`!function(r,t,j,s){(j=r.createElement(t)).type="text/javascript",
      j.async=!0,j.charset="utf-8",j.src="//js.rtoaster.jp/RTA-b526-91dfccdc03ed/rt.js",
      (s=r.getElementsByTagName(t)[0]).parentNode.insertBefore(j,s)
      }(document,"script")`}
      </script>
    ]
  }

  // 都市選択部の描画
  getDesignJL1 = () => {

    // 文言リストを取得する
    let messageList = JSON.parse(sessionStorage.getItem('messageList'));

    return (
      <Fragment>
        <div className="formWrap formWrap--center">
          <div className="ds-select">
            <select id="JS_countryList" className="ds-select__field" aria-labelledby="WA_countryList"></select>
          </div>
        </div>
        <fieldset>
          <legend className="u-screenOnly">言語</legend>
          <ul className="formRadioList formRadioList--flex formRadioList--center" data-content="JS_langSelect">
            <li className="formRadioList__item is-hide">
              <label className="ds-radio">
                <input className="ds-radio__input" type="radio" name="class-radio" data-lang="lc" />
                <span className="ds-radio__partsWrap">
                  <span className="ds-radio__parts" role="none"></span>
                  <span className="ds-radio__text JS_langSelectItemText">多言語</span>
                </span>
              </label>
            </li>
            <li className="formRadioList__item">
              <label className="ds-radio">
                <input className="ds-radio__input" type="radio" name="class-radio" data-lang="ja" />
                <span className="ds-radio__partsWrap">
                  <span className="ds-radio__parts" role="none"></span>
                  <span className="ds-radio__text JS_langSelectItemText">日本語</span>
                </span>
              </label>
            </li>
            <li className="formRadioList__item">
              <label className="ds-radio">
                <input className="ds-radio__input" type="radio" name="class-radio" data-lang="en" />
                <span className="ds-radio__partsWrap">
                  <span className="ds-radio__parts" role="none"></span>
                  <span className="ds-radio__text JS_langSelectItemText">English</span>
                </span>
              </label>
            </li>
          </ul>
        </fieldset>
        <div className="buttonLayout">
          <div className="buttonWrap buttonWrap--center">
            <div className="ds-button ds-button--tertiary ds-button--large">
              <button className="ds-button__trigger" type="button" data-btn="JS_continue">
                <span className="ds-button__label">{messageList.error.M005_home}</span>
              </button>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
  getDesignJL2 = () => {
    return (
      <Fragment>
        <div className="contentInner">
          <div className="ds-column">
            <ul className="ds-column__container ds-column--col03Pc ds-column--col01Sp">
              <li className="ds-column__item">
                <p className="u-fw-bold u-mb-12">Japan</p>
                <div className="u-d-flex u-jc-between">
                  <a href="https://www.jal.co.jp/jp/ja/" className="ds-textLink ds-textLink--chevronRight u-w-6of12">
                    日本語&nbsp;
                    <span className="ds-textLink__icon">
                      <svg className="ds-icon" width="9" height="16" aria-hidden="true">
                        <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_chevron_right`}></use>
                      </svg>
                    </span>
                  </a>
                  <a href="https://www.jal.co.jp/jp/en/" className="ds-textLink ds-textLink--chevronRight u-w-6of12">
                    English&nbsp;
                    <span className="ds-textLink__icon">
                      <svg className="ds-icon" width="9" height="16" aria-hidden="true">
                        <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_chevron_right`}></use>
                      </svg>
                    </span>
                  </a>
                </div>
                <hr className="hr" />
              </li>
              <li className="ds-column__item">
                <p className="u-fw-bold u-mb-12">USA</p>
                <div className="u-d-flex u-jc-between">
                  <a href="https://www.jal.co.jp/ar/ja/" className="ds-textLink ds-textLink--chevronRight u-w-6of12">
                    日本語&nbsp;
                    <span className="ds-textLink__icon">
                      <svg className="ds-icon" width="9" height="16" aria-hidden="true">
                        <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_chevron_right`}></use>
                      </svg>
                    </span>
                  </a>
                  <a href="https://www.jal.co.jp/ar/en/" className="ds-textLink ds-textLink--chevronRight u-w-6of12">
                    English&nbsp;
                    <span className="ds-textLink__icon">
                      <svg className="ds-icon" width="9" height="16" aria-hidden="true">
                        <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_chevron_right`}></use>
                      </svg>
                    </span>
                  </a>
                </div>
                <hr className="hr" />
              </li>
              <li className="ds-column__item">
                <p className="u-fw-bold u-mb-12">UK</p>
                <div className="u-d-flex u-jc-between">
                  <a href="https://www.jal.co.jp/uk/ja/" className="ds-textLink ds-textLink--chevronRight u-w-6of12">
                    日本語&nbsp;
                    <span className="ds-textLink__icon">
                      <svg className="ds-icon" width="9" height="16" aria-hidden="true">
                        <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_chevron_right`}></use>
                      </svg>
                    </span>
                  </a>
                  <a href="https://www.jal.co.jp/uk/en/" className="ds-textLink ds-textLink--chevronRight u-w-6of12">
                    English&nbsp;
                    <span className="ds-textLink__icon">
                      <svg className="ds-icon" width="9" height="16" aria-hidden="true">
                        <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_chevron_right`}></use>
                      </svg>
                    </span>
                  </a>
                </div>
                <hr className="hr" />
              </li>
              <li className="ds-column__item">
                <p className="u-fw-bold u-mb-12">Singapore</p>
                <div className="u-d-flex u-jc-between">
                  <a href="https://www.jal.co.jp/sg/ja/" className="ds-textLink ds-textLink--chevronRight u-w-6of12">
                    日本語&nbsp;
                    <span className="ds-textLink__icon">
                      <svg className="ds-icon" width="9" height="16" aria-hidden="true">
                        <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_chevron_right`}></use>
                      </svg>
                    </span>
                  </a>
                  <a href="https://www.jal.co.jp/sg/en/" className="ds-textLink ds-textLink--chevronRight u-w-6of12">
                    English&nbsp;
                    <span className="ds-textLink__icon">
                      <svg className="ds-icon" width="9" height="16" aria-hidden="true">
                        <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_chevron_right`}></use>
                      </svg>
                    </span>
                  </a>
                </div>
                <hr className="hr" />
              </li>
              <li className="ds-column__item">
                <p className="u-fw-bold u-mb-12">Australia</p>
                <div className="u-d-flex u-jc-between">
                  <a href="https://www.jal.co.jp/au/ja/" className="ds-textLink ds-textLink--chevronRight u-w-6of12">
                    日本語&nbsp;
                    <span className="ds-textLink__icon">
                      <svg className="ds-icon" width="9" height="16" aria-hidden="true">
                        <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_chevron_right`}></use>
                      </svg>
                    </span>
                  </a>
                  <a href="https://www.jal.co.jp/au/en/" className="ds-textLink ds-textLink--chevronRight u-w-6of12">
                    English&nbsp;
                    <span className="ds-textLink__icon">
                      <svg className="ds-icon" width="9" height="16" aria-hidden="true">
                        <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_chevron_right`}></use>
                      </svg>
                    </span>
                  </a>
                </div>
                <hr className="hr" />
              </li>
            </ul>
          </div>
        </div>
      </Fragment>
    );
  }

  // 画面表示処理
  render() {

    // 文言リストを取得する
    let messageList = JSON.parse(sessionStorage.getItem('messageList'));

    // デザイン値をセッションから読み込み
    let design = sessionStorage.getItem('design');

    // 言語判定フラグ・言語をセッションから読み込み
    let noLang = sessionStorage.getItem('noLang');
    let lang = sessionStorage.getItem('lang');

    // JH001N、またはJH004Nの場合
    if (design === "JH001N" || design === "JH004N") {

      // URLのERROR_MESSAGEパラメータに「CO-AT3100」を含む場合
      if (this.props.params && this.props.params.ERROR_MESSAGE && this.props.params.ERROR_MESSAGE.indexOf('CO-AT3100') !== -1) {
        return (
          <section className="content">

            <Helmet
              title={messageList.error.M001_title}>
            </Helmet>

            {/* 画面タイトル表示部 */}
            <div className="ds-heading ds-heading--lg">
              <h1 className="ds-heading__title">{messageList.error.M001_title}</h1>
            </div>

            {/* エラーメッセージ */}
            <div className="ds-inlineNote ds-inlineNote--attention" role="alert" aria-live="assertive">
              <div className="ds-inlineNote__details">
                <div className="ds-inlineNote__summary">
                  <h2 className="ds-inlineNote__heading">
                    <span className="ds-inlineNote__headingIcon">
                      <svg className="ds-icon" width="30" height="30" role="img" aria-label={messageList.error.M002_errorIconText}>
                        <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_attention`}></use>
                      </svg>
                    </span>
                    <span className="ds-inlineNote__headingLabel">{messageList.error.M003_errorBoxTitle}</span>
                  </h2>
                </div>
                <div className="ds-inlineNote__content">
                  <p className="ds-text">{messageList.error.M004_errorMessage1}</p>
                </div>
              </div>
            </div>

            {/* 操作ボタン表示部 */}
            <div className="buttonLayout">
              <div className="buttonWrap buttonWrap--center">
                <div className="ds-button ds-button--tertiary ds-button--large">
                  <a className="ds-button__trigger" href="https://www.jal.com/index.html">
                    <span className="ds-button__label">{messageList.error.M005_home}</span>
                  </a>
                </div>
              </div>
            </div>

          </section>
        )
      }
      // URLのERROR_MESSAGEパラメータに「UserIdentifiedKeyIsNotMatchException」を含む場合
      else if (this.props.params && this.props.params.ERROR_MESSAGE && this.props.params.ERROR_MESSAGE.indexOf('UserIdentifiedKeyIsNotMatchException') !== -1) {
        return (
          <section className="content">

            <Helmet
              title={messageList.error.M001_title}>
            </Helmet>

            {/* 画面タイトル表示部 */}
            <div className="ds-heading ds-heading--lg">
              <h1 className="ds-heading__title">{messageList.error.M001_title}</h1>
            </div>

            {/* エラーメッセージ */}
            <div className="ds-inlineNote ds-inlineNote--attention" role="alert" aria-live="assertive">
              <div className="ds-inlineNote__details">
                <div className="ds-inlineNote__summary">
                  <h2 className="ds-inlineNote__heading">
                    <span className="ds-inlineNote__headingIcon">
                      <svg className="ds-icon" width="30" height="30" role="img" aria-label={messageList.error.M002_errorIconText}>
                        <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_attention`}></use>
                      </svg>
                    </span>
                    <span className="ds-inlineNote__headingLabel">{messageList.error.M003_errorBoxTitle}</span>
                  </h2>
                </div>
                <div className="ds-inlineNote__content">
                  <p className="ds-text">{messageList.error.M004_errorMessage2}</p>
                </div>
              </div>
            </div>

            {/* 操作ボタン表示部 */}
            <div className="buttonLayout">
              <div className="buttonWrap buttonWrap--center">
                <div className="ds-button ds-button--tertiary ds-button--large">
                  <a className="ds-button__trigger" href="https://www.jal.com/index.html">
                    <span className="ds-button__label">{messageList.error.M005_home}</span>
                  </a>
                </div>
              </div>
            </div>
          </section>
        )
      }
      // URLのERROR_MESSAGEパラメータに「RecordNotFoundException」を含む場合
      else if (this.props.params && this.props.params.ERROR_MESSAGE && this.props.params.ERROR_MESSAGE.indexOf('RecordNotFoundException') !== -1) {
        return (
          <section className="content">

            <Helmet
              title={messageList.error.M001_title}>
            </Helmet>

            {/* 画面タイトル表示部 */}
            <div className="ds-heading ds-heading--lg">
              <h1 className="ds-heading__title">{messageList.error.M001_title}</h1>
            </div>

            {/* エラーメッセージ */}
            <div className="ds-inlineNote ds-inlineNote--attention" role="alert" aria-live="assertive">
              <div className="ds-inlineNote__details">
                <div className="ds-inlineNote__summary">
                  <h2 className="ds-inlineNote__heading">
                    <span className="ds-inlineNote__headingIcon">
                      <svg className="ds-icon" width="30" height="30" role="img" aria-label={messageList.error.M002_errorIconText}>
                        <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_attention`}></use>
                      </svg>
                    </span>
                    <span className="ds-inlineNote__headingLabel">{messageList.error.M003_errorBoxTitle}</span>
                  </h2>
                </div>
                <div className="ds-inlineNote__content">
                  <p className="ds-text">{messageList.error.M004_errorMessage3}</p>
                </div>
              </div>
            </div>

            {/* 操作ボタン表示部 */}
            <div className="buttonLayout">
              <div className="buttonWrap buttonWrap--center">
                <div className="ds-button ds-button--tertiary ds-button--large">
                  <a className="ds-button__trigger" href="https://www.jal.com/index.html">
                    <span className="ds-button__label">{messageList.error.M005_home}</span>
                  </a>
                </div>
              </div>
            </div>
          </section>
        )
      }
      // 「通知先が登録されない」エラー画面（OTP入力画面から遷移）
      else if (this.props.location.state &&
        (this.props.location.state.errorScreen === 'ADDRESS_UNREGISTERED_OTPLOGIN')) {
        return (
          <section className="content">

            <Helmet
              title="JAL | システムエラー/System error"
              htmlAttributes={{
                lang: "ja",
              }}>
            </Helmet>

            {/* 画面タイトル表示部 */}
            <div className="ds-heading ds-heading--lg">
              <h1 className="ds-heading__title">以下をご確認ください/<span lang="en">Please review the below</span></h1>
            </div>

            {/* 画面項目表示部 */}
            <div className="contentInner">
              <p className="ds-text">ワンタイムパスワードをお送りするメールアドレスが正しく登録されていない可能性があります。<br />
                以下のリンクよりメールアドレスを登録してください。</p>
              <div className="buttonLayout u-mt-32">
                <div className="buttonWrap buttonWrap--left">
                  <div className="ds-button ds-button--secondary ds-button--large u-d-none--sp">
                    <a className="ds-button__trigger" href="https://www121.jal.co.jp/JmbWeb/EmailRegMemInput_ja.do">
                      <span className="ds-button__label">メールアドレスを登録する</span>
                    </a>
                  </div>
                  <div className="ds-button ds-button--secondary ds-button--large u-d-none--pc">
                    <a className="ds-button__trigger" href="https://sp5971.jal.co.jp/JmbSp/EmailRegMemInput_ja.do">
                      <span className="ds-button__label">メールアドレスを登録する</span>
                    </a>
                  </div>
                </div>
              </div>
              <p className="ds-text u-mt-40" lang="en">The email address to which your one-time password will be sent may have been registered incorrectly.<br />
                Please use the link below to register your email address.</p>
              <div className="buttonLayout u-mt-32">
                <div className="buttonWrap buttonWrap--left">
                  <div className="ds-button ds-button--secondary ds-button--large">
                    <a className="ds-button__trigger" href="https://www121.jal.co.jp/JmbWeb/EmailRegMemInput_en.do" lang="en">
                      <span className="ds-button__label">Register email address</span>
                    </a>
                  </div>
                </div>
              </div>
              <div className="buttonLayout">
                <div className="buttonWrap buttonWrap--center">
                  <div className="ds-button ds-button--tertiary ds-button--large">
                    <a className="ds-button__trigger" href="https://www.jal.com/index.html">
                      <span className="ds-button__label">ホーム画面に戻る/<span lang="en">Home</span></span>
                    </a>
                  </div>
                </div>
              </div>
            </div>

          </section>
        )
      }
      // 「通知先が登録されない」エラー画面（パスワードリセット画面から遷移）
      else if (this.props.location.state &&
        (this.props.location.state.errorScreen === 'ADDRESS_UNREGISTERED_PWDRESET')) {
        return (
          <section className="content">

            <Helmet
              title="JAL | システムエラー/System error"
              htmlAttributes={{
                lang: "ja",
              }}>
            </Helmet>

            {/* 画面タイトル表示部 */}
            <div className="ds-heading ds-heading--lg">
              <h1 className="ds-heading__title">以下をご確認ください/<span lang="en">Please review the below</span></h1>
            </div>

            {/* 画面項目表示部 */}
            <div className="contentInner">
              <p className="ds-text">ワンタイムパスワードをお送りするメールアドレスが正しく登録されていない可能性があります。<br />
                以下のリンクよりメールアドレスを登録してください。</p>
              <div className="buttonLayout u-mt-32">
                <div className="buttonWrap buttonWrap--left">
                  <div className="ds-button ds-button--secondary ds-button--large u-d-none--sp">
                    <a className="ds-button__trigger" href="https://www121.jal.co.jp/JmbWeb/EmailRegMemInput_ja.do">
                      <span className="ds-button__label">メールアドレスを登録する</span>
                    </a>
                  </div>
                  <div className="ds-button ds-button--secondary ds-button--large u-d-none--pc">
                    <a className="ds-button__trigger" href="https://sp5971.jal.co.jp/JmbSp/EmailRegMemInput_ja.do">
                      <span className="ds-button__label">メールアドレスを登録する</span>
                    </a>
                  </div>
                </div>
              </div>
              <p className="ds-text u-mt-40" lang="en">The email address to which your one-time password will be sent may have been registered incorrectly.<br />
                Please use the link below to register your email address.</p>
              <div className="buttonLayout u-mt-32">
                <div className="buttonWrap buttonWrap--left">
                  <div className="ds-button ds-button--secondary ds-button--large">
                    <a className="ds-button__trigger" href="https://www121.jal.co.jp/JmbWeb/EmailRegMemInput_en.do" lang="en">
                      <span className="ds-button__label">Register email address</span>
                    </a>
                  </div>
                </div>
              </div>
              <div className="buttonLayout">
                <div className="buttonWrap buttonWrap--center">
                  <div className="ds-button ds-button--tertiary ds-button--large">
                    <a className="ds-button__trigger" href="https://www.jal.com/index.html">
                      <span className="ds-button__label">ホーム画面に戻る/<span lang="en">Home</span></span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )
      }
      // 「戻るボタン押下」エラー画面
      else if (this.props.location.state &&
        (this.props.location.state.errorScreen === 'BACKWARD_BUTTON_CLICKED')) {
        return (
          <section className="content">

            <Helmet
              title="JAL | システムエラー/System error"
              htmlAttributes={{
                lang: "ja",
              }}>
            </Helmet>

            {/* 画面タイトル表示部 */}
            <div className="ds-heading ds-heading--lg">
              <h1 className="ds-heading__title">システムエラー/<span lang="en">System error</span></h1>
            </div>

            {/* 画面項目表示部 */}
            <div className="contentInner">
              <p className="ds-text">ブラウザの戻るボタンは使用できません。<br />
                お使いのブラウザを閉じてから再度お試しください。</p>
              <p className="ds-text" lang="en">Please do not use your browser's Back button.<br />
                You will need to close and restart your browser.</p>

              {/* 操作ボタン表示部 */}
              <div className="buttonLayout">
                <div className="buttonWrap buttonWrap--center">
                  <div className="ds-button ds-button--tertiary ds-button--large">
                    <a className="ds-button__trigger" href="https://www.jal.com/index.html">
                      <span className="ds-button__label">ホーム画面に戻る/<span lang="en">Home</span></span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )
      }
      // 通常のエラー画面
      else {
        return (
          <section className="content">

            <Helmet
              title="JAL | システムエラー/System error"
              htmlAttributes={{
                lang: "ja",
              }}>
            </Helmet>

            {/* 画面タイトル表示部 */}
            <div className="ds-heading ds-heading--lg">
              <h1 className="ds-heading__title">システムエラー/<span lang="en">System error</span></h1>
            </div>

            {/* 画面項目表示部 */}
            <div className="contentInner">
              <p className="ds-text">大変申し訳ございません。システムエラーが発生しました。<br />
                もう一度、ホーム画面に戻ってお試しください。</p>
              <p className="ds-text" lang="en">A system error has occurred. We apologize for any inconvenience.<br />
                Please return to the home page and try again.</p>

              {/* 操作ボタン表示部 */}
              <div className="buttonLayout">
                <div className="buttonWrap buttonWrap--center">
                  <div className="ds-button ds-button--tertiary ds-button--large">
                    <a className="ds-button__trigger" href="https://www.jal.com/index.html">
                      <span className="ds-button__label">ホーム画面に戻る/<span lang="en">Home</span></span>
                    </a>
                  </div>
                </div>
              </div>
            </div>

          </section>
        )
      }
    }

    // JH001N・JH004N以外の場合
    else {
      // --- langboxの再生成処理 ---
      // langboxのスクリプトURLを生成
      const langboxUrl = process.env.REACT_APP_LANGBOX_DOMAIN + '/global/Y18/js/external/country_langbox_control.js';
      // すでに存在する script タグを削除
      const existingScript = document.querySelector(`script[src="${langboxUrl}"]`);
      if (existingScript) {
        existingScript.remove();
      }
      // 新しい script タグを作成して追加
      const script = document.createElement('script');
      script.src = langboxUrl;
      document.body.appendChild(script);

      // --- エラー画面表示 ---
      // URLのERROR_MESSAGEパラメータに「CO-AT3100」を含む場合
      if (this.props.params && this.props.params.ERROR_MESSAGE && this.props.params.ERROR_MESSAGE.indexOf('CO-AT3100') !== -1) {
        return (
          <section className="content">

            <Helmet
              title={messageList.error.M001_title}>
              {/* Rtoster部 */}
              {this.getDesignRtoster()}
            </Helmet>

            {/* 画面タイトル表示部 */}
            <div className="ds-heading ds-heading--lg">
              <h1 className="ds-heading__title">{messageList.error.M001_title}</h1>
            </div>

            {/* 画面項目表示部 */}
            <div className="ds-inlineNote ds-inlineNote--attention" role="alert" aria-live="assertive">
              <div className="ds-inlineNote__details">
                <div className="ds-inlineNote__summary">
                  <h2 className="ds-inlineNote__heading">
                    <span className="ds-inlineNote__headingIcon">
                      <svg className="ds-icon" width="30" height="30" role="img" aria-label={messageList.error.M002_errorIconText}>
                        <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_attention`}></use>
                      </svg>
                    </span>
                    <span className="ds-inlineNote__headingLabel">{messageList.error.M003_errorBoxTitle}</span>
                  </h2>
                </div>
                <div className="ds-inlineNote__content">
                  <p className="ds-text">{messageList.error.M004_errorMessage1}</p>
                </div>
              </div>
            </div>

            {/* 操作ボタン表示部 */}
            <hr className="hr hr--large" />
            <div className="contentInner" id="JS_countryLangBox">
              <div id="WA_countryList">
                {
                  (lang === "ja") ?
                  (<p className="ds-text u-al-center">{messageList.error.M004_errorMessage13}{messageList.error.M004_errorMessage14}</p>)
                  :
                  (<p className="ds-text u-al-center">{messageList.error.M004_errorMessage15}</p>)
                }
              </div>
              {this.getDesignJL1()}
            </div>
            {this.getDesignJL2()}

          </section>
        )
      }
      // URLのERROR_MESSAGEパラメータに「UserIdentifiedKeyIsNotMatchException」を含む場合
      else if (this.props.params && this.props.params.ERROR_MESSAGE && this.props.params.ERROR_MESSAGE.indexOf('UserIdentifiedKeyIsNotMatchException') !== -1) {
        return (
          <section className="content">

            <Helmet
              title={messageList.error.M001_title}>
              {/* Rtoster部 */}
              {this.getDesignRtoster()}
            </Helmet>

            {/* 画面タイトル表示部 */}
            <div className="ds-heading ds-heading--lg">
              <h1 className="ds-heading__title">{messageList.error.M001_title}</h1>
            </div>

            {/* 画面項目表示部 */}
            <div className="ds-inlineNote ds-inlineNote--attention" role="alert" aria-live="assertive">
              <div className="ds-inlineNote__details">
                <div className="ds-inlineNote__summary">
                  <h2 className="ds-inlineNote__heading">
                    <span className="ds-inlineNote__headingIcon">
                      <svg className="ds-icon" width="30" height="30" role="img" aria-label={messageList.error.M002_errorIconText}>
                        <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_attention`}></use>
                      </svg>
                    </span>
                    <span className="ds-inlineNote__headingLabel">{messageList.error.M003_errorBoxTitle}</span>
                  </h2>
                </div>
                <div className="ds-inlineNote__content">
                  <p className="ds-text">{messageList.error.M004_errorMessage2}</p>
                </div>
              </div>
            </div>

            {/* 操作ボタン表示部 */}
            <hr className="hr hr--large" />
            <div className="contentInner" id="JS_countryLangBox">
              <div id="WA_countryList">
                {
                  (lang === "ja") ?
                  (<p className="ds-text u-al-center">{messageList.error.M004_errorMessage13}{messageList.error.M004_errorMessage14}</p>)
                  :
                  (<p className="ds-text u-al-center">{messageList.error.M004_errorMessage15}</p>)
                }
              </div>
              {this.getDesignJL1()}
            </div>
            {this.getDesignJL2()}

          </section>
        )
      }
      // URLのERROR_MESSAGEパラメータに「RecordNotFoundException」を含む場合
      else if (this.props.params && this.props.params.ERROR_MESSAGE && this.props.params.ERROR_MESSAGE.indexOf('RecordNotFoundException') !== -1) {
        return (
          <section className="content">

            <Helmet
              title={messageList.error.M001_title}>
              {/* Rtoster部 */}
              {this.getDesignRtoster()}
            </Helmet>

            {/* 画面タイトル表示部 */}
            <div className="ds-heading ds-heading--lg">
              <h1 className="ds-heading__title">{messageList.error.M001_title}</h1>
            </div>

            {/* 画面項目表示部 */}
            <div className="ds-inlineNote ds-inlineNote--attention" role="alert" aria-live="assertive">
              <div className="ds-inlineNote__details">
                <div className="ds-inlineNote__summary">
                  <h2 className="ds-inlineNote__heading">
                    <span className="ds-inlineNote__headingIcon">
                      <svg className="ds-icon" width="30" height="30" role="img" aria-label={messageList.error.M002_errorIconText}>
                        <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_attention`}></use>
                      </svg>
                    </span>
                    <span className="ds-inlineNote__headingLabel">{messageList.error.M003_errorBoxTitle}</span>
                  </h2>
                </div>
                <div className="ds-inlineNote__content">
                  <p className="ds-text">{messageList.error.M004_errorMessage3}</p>
                </div>
              </div>
            </div>

            {/* 操作ボタン表示部 */}
            <hr className="hr hr--large" />
            <div className="contentInner" id="JS_countryLangBox">
              <div id="WA_countryList">
                {
                  (lang === "ja") ?
                  (<p className="ds-text u-al-center">{messageList.error.M004_errorMessage13}{messageList.error.M004_errorMessage14}</p>)
                  :
                  (<p className="ds-text u-al-center">{messageList.error.M004_errorMessage15}</p>)
                }
              </div>
              {this.getDesignJL1()}
            </div>
            {this.getDesignJL2()}

          </section>
        )
      }
      // 「通知先が登録されない」エラー画面（OTP入力画面から遷移）
      else if (this.props.location.state &&
        (this.props.location.state.errorScreen === 'ADDRESS_UNREGISTERED_OTPLOGIN')) {
        return (
          <section className="content">

            {
              /* 言語判定可能 */
              (noLang === "false") ?
              <Helmet
                title={messageList.error.M001_title_system}>
                {/* Rtoster部 */}
                {this.getDesignRtoster()}
              </Helmet>
              :
              /* 言語判定不可：日英併記 */
              <Helmet
                title={messageList.error.M001_browserTitle_jh}
                htmlAttributes={{
                  lang: "ja",
                }}>
                {/* Rtoster部 */}
                {this.getDesignRtoster()}
              </Helmet>
            }

            {/* 画面タイトル表示部 */}
            {
              /* 言語判定可能 */
              (noLang === "false") ?
              <div className="ds-heading ds-heading--lg">
                <h1 className="ds-heading__title">{messageList.error.M001_bodytitle_review}</h1>
              </div>
              :
              /* 言語判定不可：日英併記 */
              <div className="ds-heading ds-heading--lg">
                <h1 className="ds-heading__title">以下をご確認ください/<span lang="en">Please review the below</span></h1>
              </div>
            }

            {/* 画面項目表示部 */}
            {
              /* 言語判定可能 */
              (noLang === "false") ?
              (
              <div className="contentInner">
                <p className="ds-text">{messageList.error.M004_errorMessage8}<br />
                  {messageList.error.M004_errorMessage9}</p>
                {
                (lang === "ja") ?
                (
                  <div className="buttonLayout u-mt-32">
                    <div className="buttonWrap buttonWrap--left">
                      <div className="ds-button ds-button--secondary ds-button--large u-d-none--sp">
                        <a className="ds-button__trigger" href="https://www121.jal.co.jp/JmbWeb/EmailRegMemInput_ja.do">
                          <span className="ds-button__label">{messageList.error.M004_errorMessage10}</span>
                        </a>
                      </div>
                      <div className="ds-button ds-button--secondary ds-button--large u-d-none--pc">
                        <a className="ds-button__trigger" href="https://sp5971.jal.co.jp/JmbSp/EmailRegMemInput_ja.do">
                          <span className="ds-button__label">{messageList.error.M004_errorMessage10}</span>
                        </a>
                      </div>
                    </div>
                  </div>
                )
                :
                (<div className="buttonLayout u-mt-32">
                  <div className="buttonWrap buttonWrap--left">
                    <div className="ds-button ds-button--secondary ds-button--large">
                      <a className="ds-button__trigger" href="https://www121.jal.co.jp/JmbWeb/EmailRegMemInput_en.do">
                        <span className="ds-button__label">{messageList.error.M004_errorMessage10}</span>
                      </a>
                    </div>
                  </div>
                </div>)
                }
              </div>
              )
              :
              <Fragment>
                <div className="contentInner">
                  <p className="ds-text">ワンタイムパスワードをお送りするメールアドレスが正しく登録されていない可能性があります。<br />
                    以下のリンクよりメールアドレスを登録してください。</p>
                  <div className="buttonLayout u-mt-32">
                    <div className="buttonWrap buttonWrap--left">
                      <div className="ds-button ds-button--secondary ds-button--large u-d-none--sp">
                        <a className="ds-button__trigger" href="https://www121.jal.co.jp/JmbWeb/EmailRegMemInput_ja.do">
                          <span className="ds-button__label">メールアドレスを登録する</span>
                        </a>
                      </div>
                      <div className="ds-button ds-button--secondary ds-button--large u-d-none--pc">
                        <a className="ds-button__trigger" href="https://sp5971.jal.co.jp/JmbSp/EmailRegMemInput_ja.do">
                          <span className="ds-button__label">メールアドレスを登録する</span>
                        </a>
                      </div>
                    </div>
                  </div>
                  <p className="ds-text u-mt-40" lang="en">The email address to which your one-time password will be sent may have been registered incorrectly.<br />
                    Please use the link below to register your email address.</p>
                  <div className="buttonLayout u-mt-32">
                    <div className="buttonWrap buttonWrap--left">
                      <div className="ds-button ds-button--secondary ds-button--large">
                        <a className="ds-button__trigger" href="https://www121.jal.co.jp/JmbWeb/EmailRegMemInput_en.do" lang="en">
                          <span className="ds-button__label">Register email address</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </Fragment>
            }

            {/* 操作ボタン表示部 */}
            <hr className="hr hr--large" />
            <div className="contentInner" id="JS_countryLangBox">
              <div id="WA_countryList">
                {
                  (noLang === "false") ?
                  (
                    (lang === "ja") ?
                    (<p className="ds-text u-al-center">{messageList.error.M004_errorMessage13}{messageList.error.M004_errorMessage14}</p>)
                    :
                    (<p className="ds-text u-al-center">{messageList.error.M004_errorMessage15}</p>)
                  ):
                  (
                    <Fragment>
                      <p className="ds-text u-al-center">都市と言語を選択の上、JAL Webサイトのホームへお戻りください。</p>
                      <p lang="en" className="ds-text u-al-center">Please select your city and language, and return to the home page of the JAL website.</p>
                    </Fragment>
                  )
                }
              </div>
              {this.getDesignJL1()}
            </div>
            {this.getDesignJL2()}

          </section>
        )
      }
      // 「通知先が登録されない」エラー画面（パスワードリセット画面から遷移）
      else if (this.props.location.state &&
        (this.props.location.state.errorScreen === 'ADDRESS_UNREGISTERED_PWDRESET')) {
        return (
          <section className="content">

            {
              /* 言語判定可能 */
              (noLang === "false") ?
              <Helmet
                title={messageList.error.M001_title_system}>
                {/* Rtoster部 */}
                {this.getDesignRtoster()}
              </Helmet>
              :
              /* 言語判定不可：日英併記 */
              <Helmet
                title={messageList.error.M001_browserTitle_jh}
                htmlAttributes={{
                  lang: "ja",
                }}>
                {/* Rtoster部 */}
                {this.getDesignRtoster()}
              </Helmet>
            }

            {/* 画面タイトル表示部 */}
            {
              /* 言語判定可能 */
              (noLang === "false") ?
              <div className="ds-heading ds-heading--lg">
                <h1 className="ds-heading__title">{messageList.error.M001_bodytitle_review}</h1>
              </div>
              :
              /* 言語判定不可：日英併記 */
              <div className="ds-heading ds-heading--lg">
                <h1 className="ds-heading__title">以下をご確認ください/<span lang="en">Please review the below</span></h1>
              </div>
            }

            {/* 画面項目表示部 */}
            {
              /* 言語判定可能 */
              (noLang === "false") ?
              (
              <div className="contentInner">
                <p className="ds-text">{messageList.error.M004_errorMessage8}<br />
                  {messageList.error.M004_errorMessage9}</p>
                {
                (lang === "ja") ?
                (
                  <div className="buttonLayout u-mt-32">
                    <div className="buttonWrap buttonWrap--left">
                      <div className="ds-button ds-button--secondary ds-button--large u-d-none--sp">
                        <a className="ds-button__trigger" href="https://www121.jal.co.jp/JmbWeb/EmailRegMemInput_ja.do">
                          <span className="ds-button__label">{messageList.error.M004_errorMessage10}</span>
                        </a>
                      </div>
                      <div className="ds-button ds-button--secondary ds-button--large u-d-none--pc">
                        <a className="ds-button__trigger" href="https://sp5971.jal.co.jp/JmbSp/EmailRegMemInput_ja.do">
                          <span className="ds-button__label">{messageList.error.M004_errorMessage10}</span>
                        </a>
                      </div>
                    </div>
                  </div>
                )
                :
                (<div className="buttonLayout u-mt-32">
                  <div className="buttonWrap buttonWrap--left">
                    <div className="ds-button ds-button--secondary ds-button--large">
                      <a className="ds-button__trigger" href="https://www121.jal.co.jp/JmbWeb/EmailRegMemInput_en.do">
                        <span className="ds-button__label">{messageList.error.M004_errorMessage10}</span>
                      </a>
                    </div>
                  </div>
                </div>)
                }
              </div>
              )
              :
              <Fragment>
                <div className="contentInner">
                  <p className="ds-text">ワンタイムパスワードをお送りするメールアドレスが正しく登録されていない可能性があります。<br />
                    以下のリンクよりメールアドレスを登録してください。</p>
                  <div className="buttonLayout u-mt-32">
                    <div className="buttonWrap buttonWrap--left">
                      <div className="ds-button ds-button--secondary ds-button--large u-d-none--sp">
                        <a className="ds-button__trigger" href="https://www121.jal.co.jp/JmbWeb/EmailRegMemInput_ja.do">
                          <span className="ds-button__label">メールアドレスを登録する</span>
                        </a>
                      </div>
                      <div className="ds-button ds-button--secondary ds-button--large u-d-none--pc">
                        <a className="ds-button__trigger" href="https://sp5971.jal.co.jp/JmbSp/EmailRegMemInput_ja.do">
                          <span className="ds-button__label">メールアドレスを登録する</span>
                        </a>
                      </div>
                    </div>
                  </div>
                  <p className="ds-text u-mt-40" lang="en">The email address to which your one-time password will be sent may have been registered incorrectly.<br />
                    Please use the link below to register your email address.</p>
                  <div className="buttonLayout u-mt-32">
                    <div className="buttonWrap buttonWrap--left">
                      <div className="ds-button ds-button--secondary ds-button--large">
                        <a className="ds-button__trigger" href="https://www121.jal.co.jp/JmbWeb/EmailRegMemInput_en.do" lang="en">
                          <span className="ds-button__label">Register email address</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </Fragment>
            }

            {/* 操作ボタン表示部 */}
            <hr className="hr hr--large" />
            <div className="contentInner" id="JS_countryLangBox">
              <div id="WA_countryList">
                {
                  (noLang === "false") ?
                  (
                    (lang === "ja") ?
                    (<p className="ds-text u-al-center">{messageList.error.M004_errorMessage13}{messageList.error.M004_errorMessage14}</p>)
                    :
                    (<p className="ds-text u-al-center">{messageList.error.M004_errorMessage15}</p>)
                  ):
                  (
                    <Fragment>
                      <p className="ds-text u-al-center">都市と言語を選択の上、JAL Webサイトのホームへお戻りください。</p>
                      <p lang="en" className="ds-text u-al-center">Please select your city and language, and return to the home page of the JAL website.</p>
                    </Fragment>
                  )
                }
              </div>
              {this.getDesignJL1()}
            </div>
            {this.getDesignJL2()}

          </section>
        )
      }
      // 「戻るボタン押下」エラー画面
      else if (this.props.location.state &&
        (this.props.location.state.errorScreen === 'BACKWARD_BUTTON_CLICKED')) {
        return (
          <section className="content">

            {
              /* 言語判定可能 */
              (noLang === "false") ?
              <Helmet
                title={messageList.error.M001_title_system}>
                {/* Rtoster部 */}
                {this.getDesignRtoster()}
              </Helmet>
              :
              /* 言語判定不可：日英併記 */
              <Helmet
                title={messageList.error.M001_browserTitle_jh}
                htmlAttributes={{
                  lang: "ja",
                }}>
                {/* Rtoster部 */}
                {this.getDesignRtoster()}
              </Helmet>
            }

            {/* 画面タイトル表示部 */}
            {
              /* 言語判定可能 */
              (noLang === "false") ?
              <div className="ds-heading ds-heading--lg">
                <h1 className="ds-heading__title">{messageList.error.M001_bodytitle_system}</h1>
              </div>
              :
                /* 言語判定不可：日英併記 */
              <div className="ds-heading ds-heading--lg">
                <h1 className="ds-heading__title">システムエラー/<span lang="en">System error</span></h1>
              </div>
            }

            {/* 画面項目表示部 */}
            <div className="contentInner">
              {
                /* 言語判定可能 */
                (noLang === "false") ?
                <p className="ds-text">{messageList.error.M004_errorMessage11}<br />
                  {messageList.error.M004_errorMessage12}</p>
                :
                <Fragment>
                  <p className="ds-text">ブラウザの戻るボタンは使用できません。<br />
                    もう一度、ホーム画面に戻ってお試しください。</p>
                  <p className="ds-text" lang="en">Please do not use your browser's Back button.<br />
                    Please return to the home page and try again.</p>
                </Fragment>
              }
            </div>

            {/* 操作ボタン表示部 */}
            <hr className="hr hr--large" />
            <div className="contentInner" id="JS_countryLangBox">
              <div id="WA_countryList">
                {
                  (noLang === "false") ?
                  (
                    (lang === "ja") ?
                    (<p className="ds-text u-al-center">{messageList.error.M004_errorMessage13}{messageList.error.M004_errorMessage14}</p>)
                    :
                    (<p className="ds-text u-al-center">{messageList.error.M004_errorMessage15}</p>)
                  ):
                  (
                    <Fragment>
                      <p className="ds-text u-al-center">都市と言語を選択の上、JAL Webサイトのホームへお戻りください。</p>
                      <p lang="en" className="ds-text u-al-center">Please select your city and language, and return to the home page of the JAL website.</p>
                    </Fragment>
                  )
                }
              </div>
              {this.getDesignJL1()}
            </div>
            {this.getDesignJL2()}

          </section>
        )
      }
      // 通常のエラー画面
      else {
        return (
          <section className="content">
            {
              /* 言語判定可能 */
              (noLang === "false") ?
              <Helmet
                title={messageList.error.M001_title_system}>
                {/* Rtoster部 */}
                {this.getDesignRtoster()}
              </Helmet>
              :
              /* 言語判定不可：日英併記 */
              <Helmet
                title={messageList.error.M001_browserTitle_jh}
                htmlAttributes={{
                  lang: "ja",
                }}>
                {/* Rtoster部 */}
                {this.getDesignRtoster()}
              </Helmet>
            }

            {/* 画面タイトル表示部 */}
            {
              /* 言語判定可能 */
              (noLang === "false") ?
              <div className="ds-heading ds-heading--lg">
                <h1 className="ds-heading__title">{messageList.error.M001_bodytitle_system}</h1>
              </div>
              :
                /* 言語判定不可：日英併記 */
              <div className="ds-heading ds-heading--lg">
                <h1 className="ds-heading__title">システムエラー/<span lang="en">System error</span></h1>
              </div>
            }

            {/* 画面項目表示部 */}
            <div className="contentInner">
              {
                /* 言語判定可能 */
                (noLang === "false") ?
                <p className="ds-text">{messageList.error.M004_errorMessage4}<br />
                  {messageList.error.M004_errorMessage5}</p>
                :
                <Fragment>
                  <p className="ds-text">大変申し訳ございません。システムエラーが発生しました。<br />
                    もう一度、ホーム画面に戻ってお試しください。</p>
                  <p className="ds-text" lang="en">A system error has occurred. We apologize for any inconvenience.<br />
                    Please return to the home page and try again.</p>
                </Fragment>
              }
            </div>

            {/* 操作ボタン表示部 */}
            <hr className="hr hr--large" />
            <div className="contentInner" id="JS_countryLangBox">
              <div id="WA_countryList">
                {
                  (noLang === "false") ?
                  (
                    (lang === "ja") ?
                    (<p className="ds-text u-al-center">{messageList.error.M004_errorMessage13}{messageList.error.M004_errorMessage14}</p>)
                    :
                    (<p className="ds-text u-al-center">{messageList.error.M004_errorMessage15}</p>)
                  ):
                  (
                    <Fragment>
                      <p className="ds-text u-al-center">都市と言語を選択の上、JAL Webサイトのホームへお戻りください。</p>
                      <p lang="en" className="ds-text u-al-center">Please select your city and language, and return to the home page of the JAL website.</p>
                    </Fragment>
                  )
                }
              </div>
              {this.getDesignJL1()}
            </div>
            {this.getDesignJL2()}

          </section>
        )
      }

    }
  }
}

export default Error
